import { useEffect } from 'react';
import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import type {
  CreateTQLQueryGraphView,
  UpdateTQLQueryGraphView,
} from '@/entities/srm/tql-query';
import {
  enhanceInputProps,
  transformInputValues,
  validateInputs,
} from '@/shared/lib/utils/form/label-name-input-props';

export const initialGraphViewValues: CreateTQLQueryGraphView = {
  name: '',
  label: '',
  srm_search_query_id: '',
  display_order: 0,
  configuration: { nodes: [], edges: [] },
};

export const useGraphViewsForm = (queryId?: string) => {
  const { t } = useTranslation();
  const form = useForm<UpdateTQLQueryGraphView>({
    mode: 'uncontrolled',
    cascadeUpdates: true,
    validateInputOnBlur: true,
    validateInputOnChange: true,
    initialValues: {
      ...initialGraphViewValues,
      srm_search_query_id: queryId ?? '',
    },
    validate: validateInputs(t),
    enhanceGetInputProps: enhanceInputProps(),
    transformValues: transformInputValues(),
  });
  useEffect(() => {
    // Query details may arrive after the saved view. Keep its edited metadata.
    form.setFieldValue('srm_search_query_id', queryId ?? '');
  }, [queryId]);
  return form;
};
